import { flatten, forEach, includes } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import { WindowProxy } from '@sm360/widget-commons-core-services';
import { AnalyticsService, TRACKING_TAGS as TAGS } from '@sm360/widget-commons-general';
import MetaDataModel from 'inventory-listing/models/MetaDataModel.js';

import 'inventory-listing/components/ListingFilters/Components/ListingFiltersBrand/Models.scss';

/* eslint react/no-unused-prop-types: 1 */

class Models extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            models: this.mapModels(props.models, props.selectedModels),
        };

        this.handleClick = this.handleClick.bind(this);
    }

    componentWillReceiveProps(newProps) {
        this.setState({
            models: this.mapModels(newProps.models, newProps.selectedModels),
        });
    }

    handleClick(e, code) {
        e.preventDefault();

        const { models } = this.state;
        const selectedModels = [];

        forEach(models, (model, index) => {
            if (model.code === code) {
                models[index] = model.set('isSelected', !model.isSelected);
                if (!model.isSelected) {
                    selectedModels.push(model.code);
                    AnalyticsService.ga4Trigger(TAGS.MODELS(model.label));
                    AnalyticsService.ga4Trigger(
                        TAGS.LAYER_NAVIGATION__FILTERS(WindowProxy.location().pathname, 'modelIds')
                    );
                }
            } else {
                models[index] = model.set('isSelected', false);
            }
        });

        this.setState({
            models: this.mapModels(models, selectedModels),
        });

        this.props.updateVehicleCriteria(models, 'modelIds');
    }

    mapModels(models, selectedModels) {
        return models.map((model) => {
            return model.set('isSelected', includes(flatten(selectedModels), model.code));
        });
    }

    render() {
        const modelsList = this.state.models.filter((model) => model.count > 0).map((model) => (
            <li key={`model-${model.code}`} className="model">
                <button
                    className={model.isSelected ? 'model-label selected is-price' : 'model-label'}
                    onClick={(evt) => this.handleClick(evt, model.code)}
                >
                    {`${model.label} (${model.count})`}
                </button>
            </li>
        ));

        return <ul className="model-list">{modelsList}</ul>;
    }
}

Models.defaultProps = {
    models: [],
    make: PropTypes.object,
    noMakeListStr: '',
    modelListStr: '',
};

Models.propTypes = {
    models: PropTypes.arrayOf(PropTypes.instanceOf(MetaDataModel)),
    isMakeSelected: PropTypes.bool.isRequired,
    updateVehicleCriteria: PropTypes.func.isRequired,
    selectedModels: PropTypes.arrayOf(PropTypes.string).isRequired,
    make: PropTypes.string,
    noMakeListStr: PropTypes.string,
    modelListStr: PropTypes.string,
};

Models.displayName = 'Models';

export default Models;
